import { ComponentRef } from '@angular/core';
import { TemplateContext } from '../../../../models/reportTemplate.model';
import { EditorPropertySchema, EditorRenderStrategy } from '../../sample-widgets/widget-config.helpers';
import { SEG_STYLES } from '../seg-profile/seg-profile-presentation.service';
import { SegProfileContext, segTd, segTh } from '../seg-profile/seg-widget-config.shared';
import { SegJobRolesWidgetComponent } from './seg-job-roles-widget.component';

export function configureSegJobRolesWidget(
    componentRef: ComponentRef<unknown>,
    context: TemplateContext
): void {
    const component = componentRef.instance as SegJobRolesWidgetComponent;
    const ctx = context as SegProfileContext;
    component.profiles = ctx.computedData?.segProfiles ?? null;
}

// NOTE: the Sample Count column is always rendered — in both the Angular preview and the static
// PDF loop template — so the two stay in lock-step. A per-instance "Show Sample Counts" knob was
// intentionally NOT exposed: the static loop template cannot read a per-widget Boolean at PDF
// render time, and `data-tpl-if` cannot substitute here because `sampleCount = 0` is valid data
// (a presence guard would wrongly hide zero-sample roles). Omitting the knob avoids a false
// affordance in the template editor that would work in the live preview but not in the PDF.
export const segJobRolesLoopTemplate = [
    '[[#each computedData.segProfiles]]',
    `<div style="${SEG_STYLES.section}">`,
    `<div style="${SEG_STYLES.subHeading}">[[this.segName]] — Job Roles</div>`,
    `<table style="${SEG_STYLES.table}">`,
    '<thead>',
    '<tr>',
    segTh('Job Role'),
    segTh('Sample Count'),
    '</tr>',
    '</thead>',
    '<tbody>',
    '<tr data-tpl-each="this.jobRoles">',
    segTd('roleName'),
    segTd('sampleCount'),
    '</tr>',
    '</tbody>',
    '</table>',
    '</div>',
    '[[/each]]'
].join('\n');

export const segJobRolesLoopScopes: { loopExpr: string; label: string; fields: string[] }[] = [
    { loopExpr: 'computedData.segProfiles', label: 'Per SEG', fields: ['segName'] },
    { loopExpr: 'this.jobRoles', label: 'Per Job Role', fields: ['roleName', 'sampleCount'] }
];

export const segJobRolesEditorPropertySchema: EditorPropertySchema = {
    renderStrategy: EditorRenderStrategy.ReadOnly,
    propertySchema: []
};
